import { defineMessages } from "react-intl";

export const visibilityCardMessages = defineMessages({
  title: {
    id: "akXDST",
    defaultMessage: "Visibility",
    description: "section header",
  },
  sinceDate: {
    id: "UjsI4o",
    defaultMessage: "since {date}",
    description: "date",
  },
  setPublicationDate: {
    id: "3oQzWR",
    defaultMessage: "Set publication date",
    description: "product availability",
  },
  publishOn: {
    id: "JmdBa3",
    defaultMessage: "Publish on",
    description: "product availability publish date",
  },
  setAvailableOn: {
    id: "THpf1b",
    defaultMessage: "Set available on",
    description: "product availability available date",
  },
  hideInListings: {
    id: "jXf/9p",
    defaultMessage: "Hide in product listings",
    description: "product availability",
  },
  hideInListingsDescription: {
    id: "4VOIum",
    defaultMessage:
      "Enabling this checkbox will remove product from search and category pages. It will be available on collection pages.",
    description: "product availability",
  },
});
